import styled from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledContainer = styled.div`
	display: flex;
	gap: 10px;
	align-items: center;
	width: 340px;
	min-width: 340px;
	padding: 20px;
	background: #111314;
	border: 1px solid rgba(255, 255, 255, 0.1);
	border-radius: 10px;
	transition: background-color 0.3s ease;
	cursor: pointer;

	img {
		width: 20px;
		height: 20px;
		user-select: none;
		pointer-events: none;
		transition: filter 0.3s ease;
	}

	${Text} {
		font-weight: 500;
		font-size: 16px;
		color: #ffffff;
		transition: color 0.3s ease;
	}

	&:hover {
		background-color: #ffffff;

		${Text} {
			color: #000000;
		}

		img {
			filter: invert(100%);
		}
	}
`;

export { StyledContainer };
